import {AxiosProgressEvent} from 'axios';

import {
	PostAppointmentAttachment,
	PostAppointmentAttachmentParams,
	PostAppointmentAttachmentResponse,
} from 'domain/usecases';

import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

export class RemotePostAppointmentAttachment implements PostAppointmentAttachment {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostAppointmentAttachmentResponse>,
		private readonly onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
	) {}

	async post(
		params: PostAppointmentAttachmentParams,
	): Promise<PostAppointmentAttachmentResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url.replace(':nuControle', params?.nuControle ?? ''),
			method: 'post',
			body: {file: params.file, appointmentId: params.nuControle},
			headers: {
				'Content-Type': 'multipart/form-data',
				accept: 'text/plain',
			},
			onUploadProgress: this.onUploadProgress,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
